var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isListPage)?_c('ArticleList',{attrs:{"categoryId":_vm.pid,"pageTitle":_vm.pname,"layout":"image","detailPath":"/qualification/qualitydetail","sidebar":_vm.subCates}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }